// Styling
import style from "./layout-search.module.scss";

// Components
import IconFA from "@/components/icon-fa/icon-fa";
import SearchIcon from "@/components/search-icon/search-icon";
import Button from "@/components/button/button";

export default function LayoutSearch({
  searchType,
  searchIconSettings,
  searchClickState = {},
}) {
  return (
    <div className="layoutSearch">
      {searchType === true && (
        <div className={`${style.searchForm}`}>
          <form action="/" method="get">
            <input
              type="search"
              name="s"
              id="search"
              className="form-control"
              placeholder="Search"
            />
            <Button type="submit">
              {<IconFA name="faMagnifyingGlass" color="var(--color--font)" />}
            </Button>
          </form>
        </div>
      )}
      {searchType === false && (
        <SearchIcon
          entry={searchIconSettings}
          searchClickState={searchClickState}
        />
      )}
    </div>
  );
}
